/**
 * Integration API hooks (Sprint 18 B3 + Sprint 30).
 *
 * `useReportLessonWatched` — POST `/api/integration/xapi/lesson-watched/`
 * `useScormSession`        — GET  `/api/integration/scorm/session/<id>/`
 */

import { useMutation, useQuery } from "@tanstack/react-query";
import { apiClient } from "./client";

interface LessonWatchedPayload {
  lesson_id: number;
  duration_seconds: number;
}

export function useReportLessonWatched() {
  return useMutation<void, Error, LessonWatchedPayload>({
    mutationFn: async (payload) => {
      await apiClient.post("/integration/xapi/lesson-watched/", payload);
    },
    // KHÔNG invalidate query — fire-and-forget tracking, không affect UI
  });
}

export interface ScormSession {
  package_id: number;
  title: string;
  launcher_url: string;
  scorm_version: string;
}

export function useScormSession(packageId: number | undefined) {
  return useQuery<ScormSession>({
    queryKey: ["scorm-session", packageId],
    queryFn: async () => {
      const res = await apiClient.get<ScormSession>(
        `/integration/scorm/session/${packageId}/`
      );
      return res.data;
    },
    enabled: !!packageId,
    // Token TTL 4h — stale after 3.5h to auto-refetch before expiry
    staleTime: 3.5 * 60 * 60 * 1000,
  });
}
